<div class="modal-backdrop" (click)="this.dialogRef.close()"></div>
<div class="modal-container">
  <div class="modal">
    <div class="modal-header">
      <h3 class="modal-title">Adicionar Registro no Conselho</h3>
    </div>

    <div class="modal-body">
      @if(councilForm){
      <form [formGroup]="councilForm">
        <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
          <mat-label>Conselho Regional</mat-label>
          <mat-select formControlName="councilGroup">
            @for(councilCode of councilGroupEnum; track councilCode){
            <mat-option [value]="councilCode.code">
              <span style="font-weight: 600">{{ councilCode.code }}</span>
              {{ " - " + councilCode.description }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
          <mat-label>Número de inscrição no Conselho</mat-label>
          <input matInput formControlName="councilInscriptionNumber" />
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
          <mat-label>Estado Brasileiro</mat-label>
          <mat-select formControlName="district">
            @for(district of districtEnum; track district){
            <mat-option [value]="district.code">{{
              district.description
            }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
          <mat-label>Data de inscrição no Conselho</mat-label>
          <input
            matInput
            [matDatepicker]="picker2"
            formControlName="councilInscriptionDate"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
          <mat-label>Data da Primeira Inscrição na UF</mat-label>
          <input
            matInput
            [matDatepicker]="picker1"
            formControlName="firstInscriptionUF"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker1"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </form>
      }
    </div>

    <div class="modal-footer">
      <button
        mat-raised-button
        class="btn btn-ghost"
        (click)="this.dialogRef.close()"
      >
        Voltar sem alterar
      </button>
      <button
        mat-flat-button
        class="btn btn-primary"
        (click)="saveCouncil()"
        [disabled]="!councilForm.valid"
      >
        Salvar
      </button>
    </div>
  </div>
</div>
